import { render, staticRenderFns } from "./whatsappTemplate.vue?vue&type=template&id=74df117c&scoped=true&lang=pug&"
import script from "./whatsappTemplate.vue?vue&type=script&lang=ts&"
export * from "./whatsappTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./whatsappTemplate.vue?vue&type=style&index=0&id=74df117c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74df117c",
  null
  
)

export default component.exports